import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { FileDown, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

/** Ekipman Zekâsı sekmeleri için ortak "PDF" butonu: A4/A3 seçimi ile async üretim */
export function PdfButton({ onExport, testId, label = 'PDF', disabled, className = '' }) {
  const [busy, setBusy] = useState(false);
  const [size, setSize] = useState('a4');
  const run = async () => {
    if (busy) return;
    setBusy(true);
    try { await onExport(size); toast.success(`PDF indirildi (${size.toUpperCase()})`); }
    catch (e) { toast.error('PDF oluşturulamadı: ' + (e?.message || e)); }
    finally { setBusy(false); }
  };
  return (
    <div className={`inline-flex items-center rounded-md border border-gray-700 overflow-hidden ${className}`} data-testid={`${testId}-grup`}>
      <button onClick={() => setSize('a4')} disabled={disabled || busy} className={`px-1.5 h-7 text-[10px] ${size === 'a4' ? 'bg-gray-600 text-white' : 'bg-gray-800 text-gray-400 hover:text-white'}`} data-testid={`${testId}-a4`}>A4</button>
      <button onClick={() => setSize('a3')} disabled={disabled || busy} className={`px-1.5 h-7 text-[10px] border-l border-gray-700 ${size === 'a3' ? 'bg-gray-600 text-white' : 'bg-gray-800 text-gray-400 hover:text-white'}`} data-testid={`${testId}-a3`}>A3</button>
      <Button size="sm" variant="ghost" onClick={run} disabled={disabled || busy} className="h-7 px-2 rounded-none border-l border-gray-700 text-gray-200 hover:bg-gray-700 text-xs" title="PDF olarak indir" data-testid={testId}>
        {busy ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <FileDown className="w-3.5 h-3.5 mr-1" />} {label}
      </Button>
    </div>
  );
}

export default PdfButton;
